import { useAppSelector } from 'store';
import { selectUser } from 'store/general/general-slice-selectors';
import OrganizationRole from 'models/enums/organization-roles';
import { FleetDashboardFilters } from 'models/fleet-management/FleetDataFilter';

/**
 * Whether an insights table needs its dealer column. It does not when every row has the same
 * dealer: one dealer is selected in the filters, or the viewer is a distributor, which has no
 * dealers below it.
 */
const useShowDealerColumn = (filters: FleetDashboardFilters): boolean => {
  const role = useAppSelector((state) => selectUser(state)).data.organization.role;
  return role !== OrganizationRole.DISTRIBUTOR && filters.dealers.length !== 1;
};

export default useShowDealerColumn;
